import type { SVGProps } from 'react'
const SvgSyCritical = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd" clipRule="evenodd">
			<path
				fillOpacity={0.24}
				d="M18.52 10.186a.244.244 0 0 1 .36.013 9 9 0 0 1 2.117 5.55.245.245 0 0 1-.247.25h-4.505a.263.263 0 0 1-.258-.249 4 4 0 0 0-.7-2.022.26.26 0 0 1 .025-.333zm-.72-1.067c.11.092.115.258.014.36l-3.21 3.209a.26.26 0 0 1-.333.025 4 4 0 0 0-1.553-.643.26.26 0 0 1-.218-.254V7.278c0-.144.12-.258.264-.246A9 9 0 0 1 17.8 9.12m-6.3-1.841a.245.245 0 0 0-.264-.246A9 9 0 0 0 6.2 9.12a.244.244 0 0 0-.013.36l3.21 3.209a.26.26 0 0 0 .333.025 4 4 0 0 1 1.553-.643.26.26 0 0 0 .218-.254zm-2.786 6.45a.26.26 0 0 0-.026-.333l-3.209-3.209a.244.244 0 0 0-.36.013 9 9 0 0 0-2.116 5.55.245.245 0 0 0 .247.25h4.505c.138 0 .25-.111.258-.249.045-.728.29-1.426.7-2.022"
			/>
			<path d="M12.5 11.806c0 .126.094.231.218.254a4 4 0 0 1 1.56.646.26.26 0 0 0 .334-.026l3.91-3.91a.245.245 0 0 0-.01-.36 10 10 0 0 0-5.75-2.381.245.245 0 0 0-.262.246z" />
		</g>
	</svg>
)
export default SvgSyCritical
